/* eslint-disable react/no-array-index-key */
/*
 * This table is NOT for general use.
 */
import React from "react";
import classnames from "classnames";
import { without } from "lodash";

const styles = require("./TRUSTable.module.scss");

type CellContentFunction = (value: any) => React.ReactNode;
type CellContent = React.ReactNode | CellContentFunction;

interface ColumnProps {
  header?: React.ReactNode;
  dataKey?: string;
  children?: CellContent;
}

// Export this blank component so that the downstream syntax is cleaner.
// This allows us to initalize columns as <Column header="Title"...
export const Column: React.FC<ColumnProps> = () => null;

export const TRUSTable: React.FC<{
  data: any[];
  className?: string;
  children;

  // Controls visibility of the batch select checkbox column
  showBatchControls?: boolean;

  // Used to set the `checked` status of each checkbox:
  //  if selectedItems.contains(item), the checkbox will be checked
  selectedItems?: number[];

  // Indicates items that are currently selected in batchSelect
  setBatchSelectedItems?: Function;
}> = ({
  data,
  children,
  className = "",
  showBatchControls,
  selectedItems,
  setBatchSelectedItems,
}) => {
  const cols: any = React.Children.toArray(children);

  return (
    <table className={classnames(styles.trusTable, className === "" || className)}>
      <thead>
        <tr className={styles.row}>
          {/* Batch Select Checkbox */}
          {showBatchControls && (
            <th style={{ textAlign: "center", minWidth: "40px" }}>
              <input
                type="checkbox"
                checked={selectedItems.length === data.length}
                onChange={() => {
                  if (selectedItems.length === 0) {
                    setBatchSelectedItems(data.map(d => d.id));
                  } else {
                    setBatchSelectedItems([]);
                  }
                }}
              />
            </th>
          )}
          {cols.map(({ props: { header } }, index) => (
            <th key={index}>{header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map(row => {
          const key = row.id || row.name;
          return (
            <tr key={key} className={styles.row}>
              {/* Batch Select Checkbox */}
              {showBatchControls && (
                <td style={{ textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={selectedItems.includes(row.id)}
                    onChange={() => {
                      if (!selectedItems.includes(row.id)) {
                        setBatchSelectedItems([...selectedItems, row.id]);
                      } else {
                        setBatchSelectedItems(without(selectedItems, row.id));
                      }
                    }}
                  />
                </td>
              )}

              {cols.map(({ props: { children: renderOrContent, dataKey } }, colIndex) => {
                let content: React.ReactNode;
                if (typeof renderOrContent === "function") {
                  content = renderOrContent(row);
                } else if (dataKey) {
                  content = row[dataKey];
                } else {
                  content = renderOrContent;
                }

                return <td key={`${colIndex}_${key}`}>{content}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
